(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["custom-liquid"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('xplr-product-image-chart')) {
    customElements.define('xplr-product-image-chart', class extends HTMLElement {
      connectedCallback() {
        if (this.chartReady) return;
        const dialog = this.querySelector('dialog');
        const trigger = this.querySelector('.xplr-image-chart-trigger');
        const close = this.querySelector('.xplr-image-chart-close');
        if (!dialog || !trigger || !close) return;
        this.chartReady = true;
        trigger.addEventListener('click', () => { dialog.showModal(); trigger.setAttribute('aria-expanded', 'true'); });
        close.addEventListener('click', () => dialog.close());
        dialog.addEventListener('close', () => { trigger.setAttribute('aria-expanded', 'false'); trigger.focus(); });
        dialog.addEventListener('click', event => {
          if (event.target !== dialog) return;
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
